import i18n from './i18n';

export type TranslationVariables = {
	[id: string]: any;
};

export default function translate(id: string, variables: TranslationVariables = {}): string {
	return i18n.t(id, variables);
}
